import React from 'react';

class Dialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: true,
            message: props.message
        };
    }

 render() {
    const { className } = this.props;
    const { modal, message } = this.state;
    const backdrop = this.props.backdrop ? this.props.backdrop : true;
        return (
           <>
            <div className="modal fade show" id="exampleModal" 
            tabIndex="-1" aria-labelledby="exampleModalLabel"
             aria-modal="true" style={{display:'block'}} aria-hidden="true"  backdrop={backdrop}>
            <div className="modal-dialog">
              <div className="modal-content">
                {/* <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
                </div> */}
                <div className="modal-body text-center py-5">
                <h5>{message}</h5>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.handleNo}>No</button>
                  <button type="button" className="btn btn-success" onClick={this.toggleModal}>Yes</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
           </>
        );
    }

    toggleModal = () => {
        this.setState((prevState) => ({ modal: !prevState.modal }));
        this.props.toggleModal();
    }
    handleNo = () => {
        this.setState((prevState) => ({ modal: !prevState.modal }));
        this.props.onCancel();
    }
}

export default Dialog;